export const CONFLICT_TYPES = { 
  INCLUSION_TOO_MANY_STUDENTS: "inclusion_too_many_students",
  INCLUSION_OVER_HALF: "inclusion_over_half",
  COURSE_EXCEEDS_CAPACITY: "course_exceeds_capacity",
  COURSE_PERIOD_RESTRICTION: "course_period_restriction",
  TEACHER_MISSING: "teacher_missing",
  TEACHER_PERIOD_RESTRICTION: "teacher_period_restriction",
  TEACHER_STUDENT_RESTRICTION: "teacher_student_restriction",
  STUDENT_STUDENT_RESTRICTION: "student_student_restriction",
  CLASSROOM_MISSING: "classroom_missing",
  COURSE_OUTSIDE_NORMAL_ROOM: "course_outside_normal_room",
  TEACHER_DOUBLE_BOOKED: "teacher_double_booked",
  CLASSROOM_DOUBLE_BOOKED: "classroom_double_booked",
  STUDENT_DOUBLE_BOOKED: "student_double_booked",
  TEACHER_CONFLICTING_PERIODS: "teacher_conflicting_periods",
  CLASSROOM_CONFLICTING_PERIODS: "classroom_conflicting_periods",
  CLASSROOM_EXCEEDS_CAPACITY: "classroom_exceeds_capacity",
  STUDENT_CONFLICTING_PERIODS: "student_conflicting_periods",
  TEACHER_TOO_MANY_SECTIONS: "teacher_too_many_sections",
  TEACHER_TOO_MANY_SECTIONS_IN_A_ROW: "teacher_too_many_sections_in_a_row",
};

export const CONFLICT_TYPES_TEXT = {
  [CONFLICT_TYPES.STUDENT_DOUBLE_BOOKED]: "Student is double booked",
  [CONFLICT_TYPES.STUDENT_CONFLICTING_PERIODS]: "Student has conflicting periods",
  [CONFLICT_TYPES.STUDENT_STUDENT_RESTRICTION]: "Student has a restriction with another student",
  [CONFLICT_TYPES.TEACHER_STUDENT_RESTRICTION]: "Teacher has a restriction with a student",
  [CONFLICT_TYPES.COURSE_EXCEEDS_CAPACITY]: "Course exceeds capacity",
  [CONFLICT_TYPES.INCLUSION_TOO_MANY_STUDENTS]: "Inclusion has too many students",
  [CONFLICT_TYPES.INCLUSION_OVER_HALF]: "Inclusion is over half"
};

export const USER_ROLES = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  SUPERVISOR: 3,
  COUNSELOR: 4,
  CONSULTANT: 5,
};

export const USER_ROLES_MAP = {
  [USER_ROLES.SUPER_ADMIN]: "Super Admin",
  [USER_ROLES.ADMIN]: "Admin",
  [USER_ROLES.SUPERVISOR]: "Supervisor",
  [USER_ROLES.COUNSELOR]: "Counselor",
  [USER_ROLES.CONSULTANT]: "Consultant",
}

export const getCourseDepartmentPermissionMessage = (courseNames = []) => {
  const filteredCourseNames = Array.isArray(courseNames) ? courseNames.filter(Boolean) : [];
  const uniqueCourseNames = [...new Set(filteredCourseNames)];
  const courseCount = uniqueCourseNames.length;
  const courseList = courseCount > 0 ? uniqueCourseNames.join(", ") : "The selected course";
  const verb = courseCount <= 1 ? "is" : "are";
  const courseWord = courseCount <= 1 ? "this course" : "these courses";
  const departmentWord = courseCount <= 1 ? "your department" : "your departments";

  return `${courseList} ${verb} not in your departments. Please have an admin give you cross department permissions or add ${courseWord} to ${departmentWord}.`;
};
